import { render, staticRenderFns } from "./YouyiAI.vue?vue&type=template&id=2a2b9d06&scoped=true"
import script from "./YouyiAI.vue?vue&type=script&lang=js"
export * from "./YouyiAI.vue?vue&type=script&lang=js"
import style0 from "./YouyiAI.vue?vue&type=style&index=0&id=2a2b9d06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b9d06",
  null
  
)

export default component.exports